import { ButtonIcon, Gray100 } from '@traceair/tds';
import { CheckedIcon, CopyOutlineIcon } from '@traceair/webapp-icons';
import { classes, stylesheet } from 'typestyle';
import { useState } from 'react';

const css = stylesheet({
  icon: {
    margin: '-5px 0 -5px 1px',
    width: 16,
    minWidth: 16,
    height: 16,
    verticalAlign: -1,
  },
});

interface Props {
  className?: string;
  text: string;
  textToCopy?: string;
}

export const TextWithCopyToClipboard = ({ className, text, textToCopy }: Props) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(textToCopy ?? text);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  return (
    <span className={classes(className)}>
      {text}

      {typeof navigator.clipboard !== 'undefined' && (
        <ButtonIcon
          className={css.icon}
          size="xs"
          style="tertiary"
          icon={copied ? <CheckedIcon size={14} color={Gray100} /> : <CopyOutlineIcon size={12} color={Gray100} />}
          onClick={handleCopy}
        />
      )}
    </span>
  );
};
